const project_description_for_console = function () {
  console.group("About binary_trees");
  console.log(`binary_trees, by Stephen Boyd  
November, 2022  
Little India, Toronto, Canada.

OPR (Organizing Principle Ratio): ${window.$fxhashFeatures["The Organizing Principle Ratio"]}
Aspect Ratio: ${window.$fxhashFeatures["Aspect Ratio"]}
Colour Palette: "${window.$fxhashFeatures["Colour Palette"]}", Mark Rothko
Max search space magnitude: ${window.$fxhashFeatures["Maximum Search Space"]}
Number of search trees: ${window.$fxhashFeatures["Number of Search Trees"]}
fxhash: ${fxhash}`);

  console.groupCollapsed("Project Description");
  console.log(`The word 'algorithm' brings visions of inscrutable equations with latin symbols than can only be understood by people with acronyms after their names. In reality, algorithms can be simple. Very simple in fact. 

This project, "binary_trees", uses a simple two step algorithm to search for a secret number. 

For example, to find a secret number between 1 and 100 these are the steps:
Step 1) Pick a number between the lowest number, 1, and the highest number 100.  
Step 2) If the picked number is higher than the secret number, then set the new highest number to be the picked number.  
Or, if the picked number is lower than the secret number, then set the new lowest number to be the picked number.  

Repeat Steps 1 and 2 until the secret number is found.

That's it. Simple, but when layered and interconnected hundreds of times over, simple can become remarkably expressive. 

binary_trees repeats hundreds of these searches with each found secret number spawning new searches. Perlin noise, colour selections, arc width's and radii are used to bring a sense of structure to the visual output. 

More detail about this project and early development renders can be found in the README.md, README.pdf and test_renders/ folder. `);

  console.groupEnd();

  console.groupCollapsed("Appreciation");
  console.log(`binary_trees is a (late) contribution to the first anniversary celebration for fxhash. I am very grateful to the developers/admins/organizers and the community that makes fxhash possible.

A portion of the primary sales are split between the Processing Foundation and Tezos for Iran.

And as always, none of this is possible without my family. Thank you the most to KIRH.`);
  console.groupEnd();

  console.groupCollapsed("Keyboard Controls - Exporting to PNG");
  console.log(`This piece is dimension agnostic and can be exported to PNG format at several different sizes.

The outputs are not scaled but instead re-rendered at each of the dimensions listed below.
  
  Press t: thumbnail @ 200 x 200
  Press s: your current screen size
  Press p: print size @ 4800 x 4800 which is 16"@300dpi
  Press h: HD4K on the vertical @ 2160 x 2160
  Press m: Max size @ 10800 x 10800

The filename will include some metadata such as the unique hash, date and time at time of capture.`);
  console.groupEnd();

  console.groupCollapsed(
    `Software Libraries and other technology used for development`
  );
  console.log(`Software Libraries:
Made with Processing / P5.js  
p5.js v1.4.2

Hardware used for development:
MacBook Pro (13-inch, 2019)
Dell U2723QE

Version Control:
https://github.com/sspboyd/binary_trees

This repo is private as of November 2022. However, I have provided a source map with this project so please feel free to browse the code and see how it all works. There are a number of comments in the code explaining what is happening at different points.`);

  console.groupEnd();
  console.groupCollapsed(`Tags`);
  console.log(
    `binary_trees, generative, animated, code, geometry, geometric, generativeart, processing, p5js, 2d, abstract, colour, color, math, maths, sspboyd, Stephen_Boyd, fxhash, IPFS`
  );
  console.groupEnd();

  console.groupCollapsed(`License information`);
  console.log(`See LICENSE.md
This work is licensed under a Creative Commons
Attribution-NonCommercial-NoDerivatives 4.0 International License
http://creativecommons.org/licenses/by-nc-nd/4.0/

NFT Art and Code copyright Stephen Boyd`);
  console.groupEnd();
  console.groupCollapsed("About Stephen Boyd");
  console.log(`I live and work in the community of Little India in Toronto, Ontario, Canada.

I've been working with Processing and now P5.js to create generative art since 2004.

I am drawn to projects where I can use data as a substrate for expressing the details and relationships within the data.

My process is to sketch ideas to paper first as logic statements combined with visual relationships and then build the code up from there. I typically don't know what the visual outputs will become before the first test render.

I'm self-taught (no formal art or comp sci education) so I can proudly claim all mistakes are mine alone.

In my experience, the best outputs come from the first buggy renders before I can get in there to tweak and 'fix' things.

Find me online @sspboyd. Please say hi!

- Website, http://sspboyd.ca/
- fxhash, https://www.fxhash.xyz/u/sspboyd
- Mastodon, https://genart.social/@sspboyd
- GitHub, https://github.com/sspboyd
- Instagram, https://www.instagram.com/sspboyd
- Twitch.tv, https://www.twitch.tv/sspboyd
- Twitter, https://twitter.com/sspboyd
- Email: stephen@sspboyd.ca`);
  console.groupEnd();
  console.groupCollapsed("Contact Info");
  console.log(`- Website, http://sspboyd.ca/
- fxhash, https://www.fxhash.xyz/u/sspboyd
- Mastodon, https://genart.social/@sspboyd
- GitHub, https://github.com/sspboyd
- Instagram, https://www.instagram.com/sspboyd
- Twitter, https://twitter.com/sspboyd
- Twitch.tv, https://www.twitch.tv/sspboyd
- Email: stephen@sspboyd.ca
`);
  console.groupEnd("Contact Info");

  console.groupEnd();
};

export { project_description_for_console };
